import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  currentUser: {},
  userData: {},
  userNotificationSettings: {
    addDiscoNotifications: false,
    addActionableAlertNotifications: false,
    globalReceive: false,
    globalReceiveEmail: false,
    globalReceivePush: false,
    globalReceiveSMS: false,
    reminder: false,
  },
  userTimezone: null,
  userPropertyPermissionsList: null,
  userPropertyPermissionsTotal: 0,
  total: 0,
  currentOrgUser: {},
  totalUsers: 0,
  userPropertyTotal: 0,
  selectedProperty: null,
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
